import { ColorGroupName_CNS, ColorGroupName_CongenitalGenetic, ColorGroupName_CVS, ColorGroupName_Drugs, ColorGroupName_EarNoseThroat, ColorGroupName_EndocrineMetabolic, ColorGroupName_GastrointestinalTract, ColorGroupName_GenitoUrinary, ColorGroupName_HematologicSystem, ColorGroupName_HepatobiliarySystem, ColorGroupName_ImmuneInflammatoryLymphatic, ColorGroupName_InfectiousDiseases, ColorGroupName_IntegumentarySystem, ColorGroupName_Musculoskeletal, ColorGroupName_Ophthalmic, ColorGroupName_Psychiatric, ColorGroupName_Respiratory, ColorGroupName_Toxicity } from './consts.js';
export const ColorGroup_CVS = {
    label: ColorGroupName_CVS,
    colors: [
        '#511407',
        '#781208',
        '#A10606',
        '#C1573F',
        '#DC8F7B'
    ]
};
export const ColorGroup_Musculoskeletal = {
    label: ColorGroupName_Musculoskeletal,
    colors: [
        '#373739',
        '#5C5D60',
        '#878789',
        '#B2B3B3',
        '#D3D3D3'
    ]
};
export const ColorGroup_GenitoUrinary = {
    label: ColorGroupName_GenitoUrinary,
    colors: [
        '#705B16',
        '#AD8B14',
        '#EDBF00',
        '#F8D163',
        '#FCDE94',
    ]
};
export const ColorGroup_CNS = {
    label: ColorGroupName_CNS,
    colors: [
        '#2C4063',
        '#355A95',
        '#417ACC',
        '#84A3E2',
        '#B2C3EA',
    ]
};
export const ColorGroup_HepatobiliarySystem = {
    label: ColorGroupName_HepatobiliarySystem,
    colors: [
        '#696D19',
        '#A1A817',
        '#DDE800',
        '#E9EE63',
        '#F3F39A',
    ]
};
export const ColorGroup_Ophthalmic = {
    label: ColorGroupName_Ophthalmic,
    colors: [
        '#9AED5E',
        '#A0EE6B',
        '#A6F078',
        '#BCF49F',
        '#C4F5AD'
    ]
};
export const ColorGroup_GastrointestinalTract = {
    label: ColorGroupName_GastrointestinalTract,
    colors: [
        '#793B11',
        '#BA560E',
        '#FF7300',
        '#FFA96D',
        '#FFC79F',
    ]
};
export const ColorGroup_EndocrineMetabolic = {
    label: ColorGroupName_EndocrineMetabolic,
    colors: [
        '#1C4D62',
        '#1B7496',
        '#059ECE',
        '#7CC7EA',
        '#B1DAF1',
    ]
};
export const ColorGroup_CongenitalGenetic = {
    label: ColorGroupName_CongenitalGenetic,
    colors: [
        '#5EEDA9',
        '#6BEEB2',
        '#78F0BB',
        '#92F2CB',
        '#9FF4D3',
    ]
};
export const ColorGroup_IntegumentarySystem = {
    label: ColorGroupName_IntegumentarySystem,
    colors: [
        '#423F0F',
        '#625F0C',
        '#848000',
        '#A49E4D',
        '#C4BD87',
    ]
};
export const ColorGroup_Psychiatric = {
    label: ColorGroupName_Psychiatric,
    colors: [
        '#4C0D71',
        '#640099',
        '#9D58C4',
        '#C196D8',
        '#E9D3F3',
    ]
};
export const ColorGroup_EarNoseThroat = {
    label: ColorGroupName_EarNoseThroat,
    colors: [
        '#4D390D',
        '#73550C',
        '#9B7200',
        '#C29D54',
        '#DBC092',
    ]
};
export const ColorGroup_Respiratory = {
    label: ColorGroupName_Respiratory,
    colors: [
        '#3D4E12',
        '#658213',
        '#83AC01',
        '#83AC01',
        '#D0E19E',
    ]
};
export const ColorGroup_HematologicSystem = {
    label: ColorGroupName_HematologicSystem,
    colors: [
        '#931552',
        '#C9006E',
        '#E76D9D',
        '#FAAEC8',
        '#FECEDE',
    ]
};
export const ColorGroup_ImmuneInflammatoryLymphatic = {
    label: ColorGroupName_ImmuneInflammatoryLymphatic,
    colors: [
        '#661B65',
        '#9C1B9C',
        '#D60CD6',
        '#E568E1',
        '#FACFF6',
    ]
};
export const ColorGroup_Toxicity = {
    label: ColorGroupName_Toxicity,
    colors: [
        '#1E6259',
        '#1C9688',
        '#00CEBA',
        '#79E4D4',
        '#B2F1E6',
    ]
};
export const ColorGroup_Drugs = {
    label: ColorGroupName_Drugs,
    colors: [
        '#160771',
        '#040099',
        '#6042B4',
        '#6042B4',
        '#BEA5F1',
    ]
};
export const ColorGroup_InfectiousDiseases = {
    label: ColorGroupName_InfectiousDiseases,
    colors: [
        '#1A4D30',
        '#14663C',
        '#0C8B54',
        '#6AB387',
        '#ABD8B8',
    ]
};
export const DefaultColorGroups = [
    ColorGroup_CVS,
    ColorGroup_Musculoskeletal,
    ColorGroup_GenitoUrinary,
    ColorGroup_CNS,
    ColorGroup_HepatobiliarySystem,
    ColorGroup_Ophthalmic,
    ColorGroup_GastrointestinalTract,
    ColorGroup_EndocrineMetabolic,
    ColorGroup_CongenitalGenetic,
    ColorGroup_IntegumentarySystem,
    ColorGroup_Psychiatric,
    ColorGroup_EarNoseThroat,
    ColorGroup_Respiratory,
    ColorGroup_HematologicSystem,
    ColorGroup_ImmuneInflammatoryLymphatic,
    ColorGroup_Toxicity,
    ColorGroup_Drugs,
    ColorGroup_InfectiousDiseases,
];
export const LabelToGroupMapper = {
    [ColorGroupName_CVS]: ColorGroup_CVS,
    [ColorGroupName_Musculoskeletal]: ColorGroup_Musculoskeletal,
    [ColorGroupName_GenitoUrinary]: ColorGroup_GenitoUrinary,
    [ColorGroupName_CNS]: ColorGroup_CNS,
    [ColorGroupName_HepatobiliarySystem]: ColorGroup_HepatobiliarySystem,
    [ColorGroupName_Ophthalmic]: ColorGroup_Ophthalmic,
    [ColorGroupName_GastrointestinalTract]: ColorGroup_GastrointestinalTract,
    [ColorGroupName_EndocrineMetabolic]: ColorGroup_EndocrineMetabolic,
    [ColorGroupName_CongenitalGenetic]: ColorGroup_CongenitalGenetic,
    [ColorGroupName_IntegumentarySystem]: ColorGroup_IntegumentarySystem,
    [ColorGroupName_Psychiatric]: ColorGroup_Psychiatric,
    [ColorGroupName_EarNoseThroat]: ColorGroup_EarNoseThroat,
    [ColorGroupName_Respiratory]: ColorGroup_Respiratory,
    [ColorGroupName_HematologicSystem]: ColorGroup_HematologicSystem,
    [ColorGroupName_ImmuneInflammatoryLymphatic]: ColorGroup_ImmuneInflammatoryLymphatic,
    [ColorGroupName_Toxicity]: ColorGroup_Toxicity,
    [ColorGroupName_Drugs]: ColorGroup_Drugs,
    [ColorGroupName_InfectiousDiseases]: ColorGroup_InfectiousDiseases
};
//# sourceMappingURL=colors-v2.js.map